export const PATH = {
  HOME: "/procedure/meeting-request",
  CREATE: "/procedure/meeting-request/create/:id",
  DETAIL: "/procedure/meeting-request/detail/:id",
  EDIT: "/procedure/meeting-request/edit/:id",
};
